module.exports = __webpack_public_path__ + "static/media/cx-email-icon.e886f956.svg";